import { render } from "./JumpsPrecisionGame.vue?vue&type=template&id=3bd574c6&scoped=true"
import script from "./JumpsPrecisionGame.vue?vue&type=script&lang=js"
export * from "./JumpsPrecisionGame.vue?vue&type=script&lang=js"

import "./JumpsPrecisionGame.vue?vue&type=style&index=0&id=3bd574c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd574c6"]])

export default __exports__